/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Today_OnlyInputs */

const en_us2_workout_today_only = /** @type {(inputs: Workout_Today_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today only`)
};

const pt_br2_workout_today_only = /** @type {(inputs: Workout_Today_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só hoje`)
};

const es_419_workout_today_only = /** @type {(inputs: Workout_Today_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo hoy`)
};

const pt_pt2_workout_today_only = /** @type {(inputs: Workout_Today_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só hoje`)
};

const fr_fr2_workout_today_only = /** @type {(inputs: Workout_Today_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui seulement`)
};

const de_de2_workout_today_only = /** @type {(inputs: Workout_Today_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur heute`)
};

const it_it2_workout_today_only = /** @type {(inputs: Workout_Today_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo oggi`)
};

/**
* | output |
* | --- |
* | "Today only" |
*
* @param {Workout_Today_OnlyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_today_only = /** @type {((inputs?: Workout_Today_OnlyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Today_OnlyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_today_only(inputs)
	if (locale === "es-419") return es_419_workout_today_only(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_today_only(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_today_only(inputs)
	if (locale === "de-DE") return de_de2_workout_today_only(inputs)
	if (locale === "it-IT") return it_it2_workout_today_only(inputs)
	return en_us2_workout_today_only(inputs)
});
export { workout_today_only as "workout.today_only" }